/**
 * key is request URL
 * value is response handler function
 * @type {{}}
 */
export default Object.assign([
    // '/login',
    // '/sys/account/info',
    // '/sys/resource/navigate',
    // '/index/fileDetail',
    // '/index/loadCLLXData',
    //'/system/account/info',
    '/index/loadSFZBData',
    // '/operate/grant/queryByPage',
    '/operate/grant/removeCardGrant',
    // '/sys/organization/queryOrgTreeList',
    '/operate/grant/saveOperateGrantInfo',
    '/operate/grant/queryOperateGrantInfo',
    '/card/open',
    '/customer/queryByName',
    // '/card/queryCardPage',
    '/card/handleHk',
    '/card/handleGs',
    '/card/handleDj',
    '/card/changeCardSxDate',
    '/operate/grant/queryBindDevicePage',
    '/operate/grant/removeDeviceBind',
    '/operate/grant/queryDeviceBindInfo',
    '/operate/grant/saveDeviceBindInfo'
].reduce((result, url) => Object.assign(result, { [url]: () => generateResponseResult(url) }), {}), {});

const exDataMap = {

};

function generateResponseResult(path, { success = true, code = 200, message } = {}) {
    let data = undefined;

    try {
        data = require(`../response${path}`).default;
    } catch (e) {
        console.log(`未找到mock返回文件，默认返回空对象 ===> ${path}`);
    }

    return {
        success,
        code,
        message,
        data,
        exData: exDataMap[path]
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/intercept/index.js